import { useState } from 'react';
import { en } from '../asset';

export function useLocale() {
    // locale-switching logic would go here
    const [locale, ] = useState(en);

    return locale;
}